import type { ContainerNode, LayoutNode } from "./types.js";

/**
 * Runtime-only barLoader props produced by the behavior drain. Must not be persisted in layout JSON.
 */
const RUNTIME_BAR_LOADER_PROP_KEYS = ["barLoaderTargetPatches"] as const;

function stripRuntimeBarLoaderNodeProps(node: LayoutNode): LayoutNode {
  if (node.kind === "container") {
    const container = node as ContainerNode;
    return {
      ...container,
      children: container.children.map(stripRuntimeBarLoaderNodeProps),
    };
  }

  if (
    node.kind !== "component" ||
    node.component !== "barLoader" ||
    !node.props
  ) {
    return node;
  }

  const props = { ...(node.props as Record<string, unknown>) };
  for (const key of RUNTIME_BAR_LOADER_PROP_KEYS) {
    delete props[key];
  }
  return { ...node, props };
}

/**
 * Removes ephemeral behavior/runtime fields from a layout tree before persistence.
 */
export function stripRuntimeLayoutProps(
  doc: LayoutNode[] | undefined,
): LayoutNode[] {
  if (!doc?.length) return [];
  return doc.map(stripRuntimeBarLoaderNodeProps);
}
